import axiosClient from "axiosClient";
import axiosClientStilo from "axiosClient/indexStilo";
import { STILO } from "utilities/constants";
const adminsMode = JSON.parse(localStorage.getItem('adminsMode'))

export async function getMainFAQAPI() {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).get(`/api/v1/faq`);
}

export async function updateMainFAQAPI(data) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).post(`/api/v1/create/faq`,data);
}